const lockCount = ref(0);

export const useFixedBody = () => {
    const clampBody = () => {
        lockCount.value++;

        if (lockCount.value === 1) {
            document.documentElement.style.overflow = 'hidden';
        }
    };

    const releaseBody = () => {
        if (lockCount.value > 0) {
            lockCount.value--;
        }

        if (lockCount.value === 0) {
            document.documentElement.style.overflow = '';
        }
    };

    return {
        clampBody,
        releaseBody
    };
};
